import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  requestRegisterStart,
  requestRegisterSuccess,
  requestRegisterFail,
} from '../actions/register';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requesRegister(data) {

  /*console.log('[sages] requesRegister : ', data);*/

  const apiURL = `${url}/api/v1/auth/register`;

  //====================================================================================================================

  try {
    const { data: authen } = yield method_POST({ url: apiURL, data: data });

    /*console.log("[API] POST : ", authen);*/
    const { token } = authen;
    localStorage.setItem('token', token);

    yield put(requestRegisterSuccess(authen));

  } catch (error) {
    yield put(requestRegisterFail(error));
  }

  //====================================================================================================================

}

export function* watchRegister() {

  /*console.log('[sages] watchRegister : ✅');*/

  yield all([
    takeLatest(requestRegisterStart, requesRegister),
  ])

}



